import { NovaPluginIds } from "panels/controls/PluginAccessPanel/constants"
import { GenericTryPluginModal } from "./GenericTryPluginModal"
import { useAppDispatch, useAppSelector } from "integrations/redux/hooks"
import { createInfraredFlight } from "features/pubsub/entityActions/flights/infrared"
import { selectUserID } from "user/profile/selectors"
import { SampleDataFlightKey } from "@nova/constants"
import { hideGlobalModal } from "runlevel/actions"

export const TryHotspotsModal = () => {
    const dispatch = useAppDispatch()
    const userId = useAppSelector(selectUserID)

    const createSampleInfraredFlight = () => {
        if (!userId) return

        dispatch(
            createInfraredFlight({
                data: {
                    createdBy: {
                        userId,
                    },
                },
                context: {
                    sampleDataFlightKey: SampleDataFlightKey.ir2,
                },
            })
        )
        dispatch(hideGlobalModal())
    }

    return (
        <GenericTryPluginModal
            pluginId={NovaPluginIds.IR}
            title="Try our Hotspots for free"
            subtitle="Automated Hotspot Detection."
            body="Our AI model is trained to detect and locate heat, helping you identify
                    remaining hotspots and deploy resources exactly where it's needed."
            footer="Use pre-loaded sample data to experience this powerful tool."
            buttonTitle="Use Sample Data"
            onButtonClick={createSampleInfraredFlight}
        />
    )
}
